import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RegistrationCompleteModel } from '../../models/registration/registration.models';
import { CategoryService } from '../../services/category.service';
import { LocationService } from '../../services/location.service';
import { SelectableCategory } from '../../models/categories/category.models';
import { SelectableLocation, LocationsByRegionDto, SelectableRegion } from '../../models/locations/location.models';
import { forkJoin, Observable } from 'rxjs';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';

@Component({
    selector: 'registration-further-info',
    template: require('./registration.further.info.component.html'),
    styles: [require('./registration.further.info.component.css')]
})
export class RegistrationFurtherInfoComponent implements OnInit {
    @Input() request: RegistrationCompleteModel;
    @Output() submitFurtherInfo = new EventEmitter<any>();

    categories: Array<SelectableCategory>;
    locationsByRegion: LocationsByRegionDto;

    noCategoriesSelected = false;
    noLocationsSelected = false;

    tooManyCategoriesSelected = false;

    dialogHeader: string;
    dialogBody: string;

    categoryFilter: string;

    loading = false;

    categoriesSelected = 0;

    constructor(private categoryService: CategoryService,
        private locationService: LocationService,
        private readonly cmsDialogService: CmsDialogService) {

        this.request = new RegistrationCompleteModel();

        this.categories = new Array<SelectableCategory>();
        localStorage.setItem('tooManyCategoriesSelected', 'false');
        localStorage.setItem('categoriesSelected', '0');
        localStorage.setItem('maxCategories', '29');
    }

    ngOnInit() {

        this.cmsDialogService.getByDescription('TooManyCategories').subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
            localStorage.setItem('categoriesDialogHeader', this.dialogHeader);
            localStorage.setItem('categoriesDialogBody', this.dialogBody);
        });

        var categoryObservable = this.categoryService.getActiveCategories();
        var locationObservable = this.locationService.getActiveLocations();

        forkJoin([categoryObservable, locationObservable]).subscribe(
            ([categories, locations]) => {
                this.categories = categories;
                this.locationsByRegion = locations;
            },
            error => {
                console.error('Error occurred while fetching data', error);
            }
        );
    }

    filterCategories() {
        if (this.categoryFilter && this.categoryFilter.length >= 3) {
            var filter = this.categoryFilter.toLowerCase();
            this.categories.forEach((category: SelectableCategory) => {
                this.checkIfCategoryOrChildrenMatch(category, filter);
            });
        } else {
            this.categories.forEach((category: SelectableCategory) => { this.showCategoryAndChildren(category) });
        }
    }

    checkIfCategoryOrChildrenMatch(category: SelectableCategory, filter: string, parent?: SelectableCategory) {
        category.show = category.name.toLowerCase().indexOf(filter) > -1 ||
            (category.keywords && category.keywords.indexOf(filter) > -1);

        if (parent && category.show) {
            parent.show = true;
            parent.isExpanded = true;
        }

        category.children.forEach((child: SelectableCategory) => {
            this.checkIfCategoryOrChildrenMatch(child, filter, category);
        });
    }

    showCategoryAndChildren(category: SelectableCategory) {
        category.show = true;

        category.children.forEach((child: SelectableCategory) => { this.showCategoryAndChildren(child) });
    }

    changeRegionSelected(region: SelectableRegion) {
        region.locations.forEach((location: SelectableLocation) => {
            location.isSelected = region.isSelected;
        });
    }

    changeLocationSelected(location: SelectableLocation, region?: SelectableRegion) {
        if (!region) {
            return;
        }

        if (region.locations.every((l: SelectableLocation) => { return l.isSelected })) {
            region.isSelected = true;
        } else if (region.locations.every((l: SelectableLocation) => { return !l.isSelected })) {
            region.isSelected = false;
        }
    }

    private checkCategorySelection = (category: SelectableCategory) => {

        if (category.isSelected) {
            this.request.categoryIds.push(category.id);
        }

        category.children.forEach((child: SelectableCategory) => {
            this.checkCategorySelection(child);       
        });
    }


    categoriesChanged(event) {
        var categoriesSelectedCount = 0;
        this.categories.forEach((category: SelectableCategory) =>
        {
            if (category.children.length == 0) {
                if (category.isSelected) {
                    categoriesSelectedCount++;
                }
            }
            else {
                category.children.forEach((child: SelectableCategory) => {
                    if (child.isSelected) {
                        categoriesSelectedCount++;
                    }
                });
            }
        });

        localStorage.setItem('categoriesSelected', categoriesSelectedCount.toString());

        if (categoriesSelectedCount == 29) {
            this.tooManyCategoriesSelected = false;
            localStorage.setItem('tooManyCategoriesSelected', 'true');
        }
        else if (categoriesSelectedCount > 29) {
            this.tooManyCategoriesSelected = true;
            localStorage.setItem('tooManyCategoriesSelected', 'true');
        }
        else {
            this.tooManyCategoriesSelected = false;
            localStorage.setItem('tooManyCategoriesSelected', 'false');
        }
    }

    checkLocationSelection = (location: SelectableLocation) => {
        if (location.isSelected) {
            this.request.locationIds.push(location.id);
        }
    }

    savePreferences() {
        this.noCategoriesSelected = false;
        this.noLocationsSelected = false;
        this.tooManyCategoriesSelected = false;
        this.loading = true;
        this.request.categoryIds = [];

        this.categories.forEach((category: SelectableCategory) => { this.checkCategorySelection(category); });
        
        this.locationsByRegion.regions.forEach((r: SelectableRegion) => {
            r.locations.forEach((l: SelectableLocation) => { this.checkLocationSelection(l); });
        });

        this.locationsByRegion.locationsWithoutRegion.forEach((l: SelectableLocation) => {
            this.checkLocationSelection(l);
        });

        if (this.request.categoryIds.length === 0) {
            this.noCategoriesSelected = true;
            this.loading = false;
            return;
        }

        if (this.request.locationIds.length === 0) {
            this.noLocationsSelected = true;
            this.loading = false;
            return;
        }

        var categoriesSelectedCount = 0;
        this.categories.forEach((category: SelectableCategory) => {
            if (category.children.length == 0) {
                if (category.isSelected) {
                    categoriesSelectedCount++;
                }
            }
            else {
                category.children.forEach((child: SelectableCategory) => {
                    if (child.isSelected) {
                        categoriesSelectedCount++;
                    }
                });
            }
        });

        if (categoriesSelectedCount > 29) {
            this.tooManyCategoriesSelected = true;
            this.loading = false;
            return;
        }

        this.submitFurtherInfo.emit();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/registration.further.info.component.ts